import React, { useState } from 'react'
import { useChannelStateContext } from 'stream-chat-react'
import { msgid, ngettext, t } from 'ttag'
import Box from '@material-ui/core/Box'
import YumButton from '../../../components/YumButton/YumButton'
import YumChatMembersModal from '../../../components/YumChatView/YumChatMembersModal'
import YumChatMoreMenu from '../../../components/YumChatView/YumChatMoreMenu'
import { ChatChannelKind } from '../../../components/YumChatView/useChatChannel'
import { getUserGoal } from '../../Activity/store/ActivitySelectors'
import { store } from '../../../index'
import { IGlobalState } from '../../../Root/store/appReducer'
import { isRtl } from '../../../i18nInit'

import { ReactComponent as ChallengeIcon } from '../../../assets/v3/icons/challenge.svg'
import { ReactComponent as GroupIcon } from '../../../assets/v3/icons/group-active.svg'
import { ReactComponent as ArrowForwardIcon } from '../../../assets/v3/icons/arrow-forward.svg'

export interface IChatHeaderProps {
  kind: ChatChannelKind
}

// Rendered inside YumChatView's <Channel>, so the channel state context is available.
export default function ChatHeader(props: IChatHeaderProps) {
  const { kind } = props
  const { channel, watcher_count } = useChannelStateContext('ChatHeader')
  const [membersOpen, setMembersOpen] = useState(false)

  // @ts-ignore // image, name and member_count exist on channel data
  const { image, name, member_count } = channel?.data || {}
  const memberCount: number = member_count || 0
  const watcherCount: number = watcher_count || 0
  // Challenge channel ids are the goalId.
  const goalId = kind === 'challenge' ? channel?.id : undefined
  const goal = goalId ? getUserGoal(store.getState() as any as IGlobalState, goalId) : undefined

  return (
    <div className="chat-header">
      <div className="chat-header__avatar" aria-hidden="true">
        {image ? <img src={image} alt="" /> : kind === 'challenge' ? <ChallengeIcon /> : <GroupIcon />}
      </div>
      <div className="chat-header__info">
        <div className="chat-header__name">{name || ''}</div>
        {memberCount > 0 && (
          <div className="chat-header__subtitle">
            <button
              type="button"
              className="chat-header__members-link"
              onClick={() => setMembersOpen(true)}
              aria-haspopup="dialog"
            >
              {ngettext(msgid`${memberCount} member`, `${memberCount} members`, memberCount)}
            </button>
            {' · '}
            {t`${watcherCount} online`}
          </div>
        )}
      </div>
      <div className="chat-header__action">
        {channel && <YumChatMoreMenu channel={channel} goalId={goalId} companyId={goal?.companyId} />}
        {goalId && (
          <YumButton
            variant="outlined"
            size="small"
            to={`/challenges/${goalId}/ranking`}
            aria-label={t`Open challenge`}
          >
            <Box display="inline" style={isRtl ? { marginLeft: '2px' } : { marginRight: '2px' }}>
              {t`Challenge`}
            </Box>
            <ArrowForwardIcon style={{ width: '1rem', height: '1rem' }} aria-hidden="true" />
          </YumButton>
        )}
      </div>
      <YumChatMembersModal open={membersOpen} onClose={() => setMembersOpen(false)} channel={channel} />
    </div>
  )
}
